import { createContext } from 'react'

type ContextProps = {
  setMap: (map: google.maps.Map | null) => void
  map: google.maps.Map | null
  setLoadingData: (value: boolean) => void
  loadingData: boolean
}

export const MapContext = createContext<ContextProps>({
  setMap: () => {},
  map: null,
  setLoadingData: () => {},
  loadingData: false,
})
